module.exports = __webpack_public_path__ + "static/media/iconfinder_ic_control_point_48px_352288.6cea128d.svg";